import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { LibConfigService, LibConfig } from './app/shared/enrollment/libconfig.service';
import { APP_BASE_HREF, DatePipe, CommonModule } from '@angular/common';
import { AuthService } from './app/authentication/auth.service';
import { AppSettingsService } from './app/services/common/appsettings.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withFetch, HttpClient } from '@angular/common/http';
import { AuthInterceptor } from './app/services/common/auth.interceptor';
import { CookieService } from 'ngx-cookie-service';
import { TreeviewModule } from '@samotics/ngx-treeview';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { ApiModule as MasterApiModule } from './app/services/master';
import { apiMaster, apiAnalytics, apiUser, apiFileStore, apiActivitylogging, apiNotification, apiIdentity, apiOrganization, apiConditionalAccess, apiMigration, apiReport, apiAnomalyDetection } from './app/services/common/configuration.service';
import { ApiModule as AnalyticsApiModule } from './app/services/analytics';
import { ApiModule as ApiUserModule } from './app/services/user';
import { ApiModule as FileStoreApiModule } from './app/services/fileStore';
import { ApiModule as ActivityLoggingApiModule } from './app/services/activitylogging';
import { ApiModule as NotificationApiModule } from './app/services/notification';
import { ApiModule as IdentityApiModule } from './app/services/identity';
import { ApiModule as OrganizationApiModule } from './app/services/organization';
import { ApiModule as ConditionalAccessApiModule } from './app/services/conditional-access';
import { ApiModule as MigrationApiModule } from './app/services/migration';
import { ApiModule as ReportApiModule } from './app/services/report';
import { ApiModule as AnomalyDetectionApiModule } from './app/services/anomalydetection';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SettingsService } from './app/services/common/settings.service';
import { routes } from './app/app.routes';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgChartsModule } from 'ng2-charts';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxIntlTelInputModule } from '../local_node_modules/ngx-intl-tel-input';
import { DataTablesModule } from 'angular-datatables';
import { provideAnimations } from '@angular/platform-browser/animations';
import { SharedModule } from './app/shared/shared.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { LaddaModule } from 'angular2-ladda';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { CustomTranslateLoader } from './app/services/translate/custom.translate.loader';
import { NgIdleModule } from '@ng-idle/core';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import '@angular/common/locales/global/ar';
import '@angular/common/locales/global/de';
import '@angular/common/locales/global/es';
import '@angular/common/locales/global/fr';
import { App } from './app/app';
import { provideSpartanHlm } from '@spartan-ng/helm/utils';

registerLocaleData(localeEn);
registerLocaleData(localeDe);
registerLocaleData(localeEs);
registerLocaleData(localeFr);
registerLocaleData(localeIt);

const libConfig: LibConfig = {
  production: environment.production,
  pushCheckTime: environment.pushCheckTime,
};

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(App, {
  providers: [
    provideZoneChangeDetection(),
    provideSpartanHlm(),
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ onSameUrlNavigation: 'reload' })),
    importProvidersFrom(TreeviewModule.forRoot(), BrowserModule, CommonModule, MasterApiModule.forRoot(() => apiMaster()), AnalyticsApiModule.forRoot(() => apiAnalytics()), ApiUserModule.forRoot(() => apiUser()), FileStoreApiModule.forRoot(() => apiFileStore()), ActivityLoggingApiModule.forRoot(() => apiActivitylogging()), NotificationApiModule.forRoot(() => apiNotification()), IdentityApiModule.forRoot(() => apiIdentity()), OrganizationApiModule.forRoot(() => apiOrganization()), ConditionalAccessApiModule.forRoot(() => apiConditionalAccess()), MigrationApiModule.forRoot(() => apiMigration()), ReportApiModule.forRoot(() => apiReport()), AnomalyDetectionApiModule.forRoot(() => apiAnomalyDetection()), FormsModule, ReactiveFormsModule, SettingsService, NgbModule, NgChartsModule, RecaptchaModule, RecaptchaFormsModule, NgSelectModule, NgxIntlTelInputModule, DataTablesModule, SharedModule, GoogleMapsModule, LaddaModule.forRoot({
        style: 'expand-left',
        spinnerSize: 30,
        spinnerColor: 'white',
        spinnerLines: 12
    }), ToastrModule.forRoot({
        timeOut: 3000, // 5 seconds
        closeButton: true,
        progressBar: true,
    }), TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useClass: CustomTranslateLoader,
            deps: [HttpClient, AppSettingsService],
        },
    }), 
    NgIdleModule.forRoot()),
    { provide: LibConfigService, useValue: libConfig },
    { provide: APP_BASE_HREF, useValue: '/' },
    AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    CookieService,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideAnimations()
  ]
})
  .catch(err => console.error(err));
